"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassUtil_1 = require("../util/ClassUtil");
var KeyDerivationUtil_1 = require("../util/KeyDerivationUtil");
var MemoryUtil_1 = require("../util/MemoryUtil");
var CipherKey_1 = require("./CipherKey");
var MacKey_1 = require("./MacKey");
var DerivedSecrets = (function () {
    function DerivedSecrets() {
        this.cipher_key = new CipherKey_1.default();
        this.mac_key = new MacKey_1.default(new Uint8Array([]));
    }
    DerivedSecrets.kdf = function (input, salt, info) {
        var byte_length = 64;
        var output_key_material = KeyDerivationUtil_1.default.hkdf(salt, input, info, byte_length);
        var cipher_key = new Uint8Array(output_key_material.buffer.slice(0, 32));
        var mac_key = new Uint8Array(output_key_material.buffer.slice(32, 64));
        MemoryUtil_1.default.zeroize(output_key_material.buffer);
        var ds = ClassUtil_1.default.new_instance(DerivedSecrets);
        ds.cipher_key = CipherKey_1.default.new(cipher_key);
        ds.mac_key = new MacKey_1.default(mac_key);
        return ds;
    };
    DerivedSecrets.kdf_without_salt = function (input, info) {
        return this.kdf(input, new Uint8Array(0), info);
    };
    return DerivedSecrets;
}());
exports.default = DerivedSecrets;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/derived/DerivedSecrets.js
// module id = 43
// module chunks = 0 1